import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withApollo } from 'react-apollo';
import { injectIntl, intlShape } from 'react-intl';
import { SubmissionError } from 'redux-form';
import gql from 'graphql-tag';
import OrderForm from './OrderForm';
import analytics from '../../lib/analytics';
import errorCodes from '../../lib/errorCodes';
import noop from '../../lib/noop';

function OrderFormContainer(props) {
  return (
    <OrderForm
      {...props}
      onSubmit={async values => {
        const {
          client,
          intl,
          event,
          nextRegisterExtensionStep,
          preOrder,
          ticketsCount,
          onSubmit,
          registerFormFields,
        } = props;

        try {
          await client.query({
            query: validateOrderTickets,
            variables: { eventId: event.id, tickets: values.tickets },
          });
        } catch (error) {
          const validationError = error.graphQLErrors.find(
            ({ code }) => code === errorCodes.validation,
          );

          const errors = {
            _error: validationError ? undefined : 'error',
            tickets: values.tickets.map(() => ({ person: {} })),
          };

          if (validationError) {
            Object.keys(validationError.state).forEach(ticketIndex => {
              Object.keys(validationError.state[ticketIndex] || {}).forEach(fieldId => {
                errors.tickets[ticketIndex].person[fieldId] = intl.formatMessage(
                  { id: validationError.state[ticketIndex][fieldId] },
                  {
                    field: intl.formatMessage({
                      id: registerFormFields.find(({ id }) => id === fieldId).type,
                    }),
                  },
                );
              });
            });
          }

          throw new SubmissionError(errors);
        }

        analytics
          .record(
            'preOrderPersons',
            {
              event: {
                id: event.id,
              },
              preOrder: {
                ...preOrder,
                ticketsCount,
              },
              order: {
                ...values,
                ticketsCount,
              },
            },
            event.id,
          )
          .catch(noop);

        if (preOrder.totalValue) {
          return nextRegisterExtensionStep();
        }

        return onSubmit(values);
      }}
    />
  );
}

OrderFormContainer.propTypes = {
  client: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  event: PropTypes.object.isRequired,
  nextRegisterExtensionStep: PropTypes.func.isRequired,
  preOrder: PropTypes.object.isRequired,
  ticketsCount: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const validateOrderTickets = gql`
  query validateOrderTickets($eventId: String!, $tickets: [TicketInput!]!) {
    validateOrderTickets(eventId: $eventId, tickets: $tickets)
  }
`;

export default compose(
  withApollo,
  injectIntl,
)(OrderFormContainer);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/OrderForm/OrderFormContainer.js